import { useState, useMemo } from "react";

export const useUserFilters = ({ users = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const safeUsers = useMemo(() => (Array.isArray(users) ? users : []), [users]);

  const transformedData = useMemo(
    () =>
      safeUsers.map((user) => ({
        ...user,
        name: `${user.firstname || ""} ${user.lastname || ""}`.trim(),
        role:
          user.roles && user.roles.length > 0
            ? user.roles.map((role) => role.replace("ROLE_", "")).join(", ")
            : "N/A",
      })),
    [safeUsers],
  );

  const filteredUsers = useMemo(() => {
    if (!searchTerm) return transformedData;

    const term = searchTerm.toLowerCase();

    return transformedData.filter((user) => {
      const first = user.firstname?.toLowerCase() || "";
      const last = user.lastname?.toLowerCase() || "";
      const email = user.email?.toLowerCase() || "";
      const roles =
        user.roles
          ?.map((r) => r.replace("ROLE_", "").toLowerCase())
          .join(" ") || "";

      return (
        first.includes(term) ||
        last.includes(term) ||
        email.includes(term) ||
        roles.includes(term)
      );
    });
  }, [transformedData, searchTerm]);

  const noUsers = transformedData.length === 0;
  const noResults = transformedData.length > 0 && filteredUsers.length === 0;

  return {
    searchTerm,
    setSearchTerm,
    filteredUsers,
    noUsers,
    noResults,
  };
};

export default useUserFilters;
